import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import {
  ReportActions,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

// report 064
export function HighLevelTournamentSchoolAdminsAreaSideReportForm(props: Props) {
  const requestInitial = {
    isShowAllAdmins: true
  };

  return (
    <Formik
      onSubmit={values => {
        props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.HIGH_LEVEL_TOURNAMENT_SCHOOL_ADMINS_AREA_SIDE);
      }}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm highLevelTournamentReportForm">
          <div className="eReportForm__content">
            <ReportDescription>
              View participating schools and their contact details, including schools represented through an area team.
            </ReportDescription>

            <ReportSection
              number={1}
              title="Administrator details"
              hint="Choose how much school administrator information to include."
            >
              <ReportToggleList>
                <ReportToggle
                  name="isShowAllAdmins"
                  label="Include all school administrators"
                  hint="List every user who holds the Admin role at each represented school."
                  value={values.isShowAllAdmins}
                  onChange={value => setFieldValue('isShowAllAdmins', value)}
                />
              </ReportToggleList>
            </ReportSection>
          </div>
          <ReportActions onCancel={props.onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}

